import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import InitialContext from 'state/static-data/InitialContext';
import { ApplicationState } from 'state/store/configureStore';
import { Merchant } from 'state/types/merchants';

const FEATURE_NAME = `all-merchants`;

const adaptor = createEntityAdapter<Merchant>({
  selectId: (m) => m.obfuscatedMerchantId,
});

const initialState = adaptor.upsertMany(adaptor.getInitialState(), InitialContext.getMerchants());
const slice = createSlice({
  name: FEATURE_NAME,
  initialState: initialState,
  reducers: {
  },
});

export const {
  selectById: selectMerchantById,
  selectAll: selectAllMerchants
} = adaptor.getSelectors<ApplicationState>(state => state.merchantsState);

export default slice.reducer;
